import {useState, useContext, createContext} from 'react';
import {HeaderEntity} from '~/types';

export const HeaderContext = createContext<HeaderEntity | undefined>(undefined);
export function useHeaderContext() {
  const context = useContext(HeaderContext);

  if (!context) {
    throw new Error('No header context found');
  }

  return context;
}

export default function HeaderProvider({
  value,
  children,
}: {
  value?: HeaderEntity;
  children: React.ReactNode;
}) {
  const [header] = useState(value);

  return (
    <HeaderContext.Provider value={header}>{children}</HeaderContext.Provider>
  );
}
